<template>
    <mobile-card>
        <template slot="title">
            <div class="charge-card-title">
                {{item.name}}
            </div>
        </template>

        <template slot="content">
            <div class="charge-card-info" v-for="(detail,index) in item.details" :key="index">
                <div class="left">{{detail.name}}</div>
                <div class="right link" style="color: #005423" v-if="detail.type==='money'">{{detail.value |
                    formatMoney}}
                </div>
                <div class="right" style="min-width:0;" v-else-if="detail.type==='remark'">{{detail.value}}
                </div>
                <div class="right" v-else>{{detail.value || '--'}}</div>
            </div>
        </template>
    </mobile-card>
</template>
<script>
    import MobileCard from "components/mobile-card/index";

    export default {
        name: "paySucDetail",
        components: {MobileCard},
        props: {
            item: Object,
        },
        data() {
            return {}
        },
        watch: {},
        methods: {},
        mounted() {

        },
        created() {
        },
    }
</script>
<style lang="scss" scoped>
    .charge-card-title {
        /*font-size: 16px;*/
        /*font-weight: bold;*/
        color: #005423;
        background: #e9e9e9;
        height: 6vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 5px 5px 0 0;
    }

    .charge-card-info {
        display: flex;
        justify-content: space-between;
        padding: 5px 4vw;
        overflow-wrap: break-word;
    }


    .charge-card {
        width: 90vw;
        margin: 2vh auto;
        background: #ffffff;
        border-radius: 5px;


        .card-info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding: 2vw 4vw;
            padding: 10px 16px;

            .left {
                flex: auto;
                text-align: left;
                vertical-align: center;
            }

            .right {
                flex: auto;
                text-align: right;
            }
        }
    }
</style>
